module.exports = __webpack_public_path__ + "static-portal/img/login-4.9f57a13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-4.png
// module id = SyFL
// module chunks = 4